import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import * as types from "./mutations_types.js"

import { api } from "@/utils/api.js"

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    Browser: {},
    smallDevice: false,
    login: false,
    toggleSidebar: false,
    toggleMainSidebar: true,
    userInfoThrowError: false,
    UserLoginData: {},
    alertMessage: {},
    storeCallback: {},
    redirectUrl: "",
    language: "",
    Loading: null,
    /***************-BASE-***************/
    regionBase: [],
    areaBase: [],
    factoryBase: [],
    locationBase: [],
    cartypeBase: [],
    gateBase: [],
    roleBase: [],
    jobBase: [],
    carColorBase: [],
    enterReasonBase: [],
    regionAreaFactory: [],
    codeCultureBase: [],
    /***************-FACTORY MAINTAIN-***************/
    locationTable: [],
    cartypeTable: [],
    locationByFactory: [],
    /***************-AUTH-***************/
    userInfo: {},
    authTable: [],
    /***************-VENDOR-***************/
    carTable: [],
    driverTable: [],
    vendorTable: [],
    carDataInfo: [],
    driverDataInfo: [],
    contactDataInfo: [],
    vendorDataInfo: {},
    vendorByOACode: "",
    vendorAreaByOACode: [],
    vendorFactoryById: [],
    vendorWithPasswordChange: [],
    vendorFactoryByOacode: [],
    /***************-RESERVE-***************/
    reserveTable: [],
    queryReserveTable: [],
    reserveInfo: {},
    releaseNum: [],
    /***************-GUARD-***************/
    guardReservationList: {},
    /***************-RELEASE-***************/
    releaseTable: [],
    releaseInfo: {},
    soCredit: {},
    releaseANSoUpdated: {},
    signTable: [],
    /****************KEEP-SEARCH RESERVE****************/
    keepSearchReserve: {
      deltaContactName: "",
      vendor: "",
      reserveNo: "",
      OACode: "",
      reserveArea: "",
      enterReason: "",
      reserveFactory: "",
      reserveStatus: "",
      reserveArriveTime: [],
      applyDatetime: [],
    },
    keepSearchVendor: {
      oacode: "",
      vendor: "",
      area: "",
      driverName: "",
      carPlat: "",
      driverLicience: "",
      carState: "",
      driverState: "",
      carType: "",
    },
    keepSearchFactory: {
      region: "",
      area: "",
      factory: "",
      cartype: "",
    },
    keepSearchAuth: {
      region: "",
      area: "",
      factory: "",
      role: "",
      userName: "",
      userID: "",
      userPhone: "",
      userMail: "",
    },
  },
  getters: {
    getSmallDevice: (state) => state.smallDevice,
    toggleSidebar: (state) => state.toggleSidebar,
    getToggleMainSidebar: (state) => state.toggleMainSidebar,
    getLogin: (state) => state.login,
    getRedirectUrl: (state) => state.redirectUrl,
    getLanguage: (state) => state.language,
    alertMessage: (state) => state.alertMessage,
    storeCallback: (state) => state.storeCallback,
    getUserProfile: (state) => state.UserLoginData,
    getUserRoles: (state) => state.UserLoginData.userLoginRole,
    getUserInfoThrowError: (state) => state.userInfoThrowError,
    /***************-KEEP-***************/
    keepSearchReserve: (state) => state.keepSearchReserve,
    getKeepSearchVendor: (state) => state.keepSearchVendor,
    getKeepSearchFactory: (state) => state.keepSearchFactory,
    getKeepSearchAuth: (state) => state.keepSearchAuth,
    keepSearchVendorReserve: (state) => state.keepSearchVendorReserve,
    /***************-BASE-***************/
    regionBase: (state) => state.regionBase,
    areaBase: (state) => state.areaBase,
    factoryBase: (state) => state.factoryBase,
    locationBase: (state) => state.locationBase,
    cartypeBase: (state) => state.cartypeBase,
    gateBase: (state) => state.gateBase,
    roleBase: (state) => state.roleBase,
    jobBase: (state) => state.jobBase,
    carColorBase: (state) => state.carColorBase,
    enterReasonBase: (state) => state.enterReasonBase,
    getRegionAreaByFactory: (state) => state.getRegionAreaByFactory,
    regionAreaFactory: (state) => state.regionAreaFactory,
    codeCultureBase: (state) => state.codeCultureBase,
    getSysCodeText: (state) => (type, code) => {
      if (
        type &&
        code &&
        state.codeCultureBase[type] &&
        state.codeCultureBase[type][code] &&
        state.codeCultureBase[type][code][state.language]
      ) {
        return state.codeCultureBase[type][code][state.language]
      } else return ""
    },
    sortDDL: (state) => (list) => {
      let newObj = Object.assign([], list)
      newObj.sort(function (a, b) {
        if (a["code"] == "Others") return 1
        else if (b["code"] == "Others") return -1
        switch (state.language) {
          case "zh-cn":
          case "zh-tw":
            return a[state.language].localeCompare(b[state.language], "zh-Hant")
          default:
            return a["en"] > b["en"]
        }
      })
      return newObj
    },
    /***************-FACTORY MAINTAIN-***************/
    locationTable: (state) => state.locationTable,
    cartypeTable: (state) => state.cartypeTable,
    locationByFactory: (state) => state.locationByFactory,
    /***************-Athu-***************/
    userInfo: (state) => state.userInfo,
    authTable: (state) => state.authTable,
    /***************-VENDOR-***************/
    carTable: (state) => state.carTable,
    driverTable: (state) => state.driverTable,
    vendorTable: (state) => state.vendorTable,
    carDataInfo: (state) => state.carDataInfo,
    driverDataInfo: (state) => state.driverDataInfo,
    contactDataInfo: (state) => state.contactDataInfo,
    vendorDataInfo: (state) => state.vendorDataInfo,
    vendorByOACode: (state) => state.vendorByOACode,
    vendorAreaByOACode: (state) => state.vendorAreaByOACode,
    vendorFactoryById: (state) => state.vendorFactoryById,
    vendorFactoryByOacode: (state) => state.vendorFactoryByOacode,
    vendorWithPasswordChange: (state) => state.vendorWithPasswordChange,
    /***************-RESERVE-***************/
    reserveTable: (state) => state.reserveTable,
    queryReserveTable: (state) => state.queryReserveTable,
    reserveInfo: (state) => state.reserveInfo,
    releaseNum: (state) => state.releaseNum,
    /***************-GUARD-***************/
    guardReservationList: (state) => state.guardReservationList,
    /***************-RELEASE-***************/
    releaseTable: (state) => state.releaseTable,
    releaseInfo: (state) => state.releaseInfo,
    soCredit: (state) => state.soCredit,
    releaseANSoUpdated: (state) => state.releaseANSoUpdated,
    signTable: (state) => state.signTable,
  },
  mutations: {
    /***************-GENERATE-***************/
    [types.LOGIN](state, login) {
      state.login = login
    },
    [types.REDIRECT_URL](state, redirectUrl) {
      state.redirectUrl = redirectUrl
    },
    [types.USERINFO_THROW_ERROR](state, userInfoThrowError) {
      state.userInfoThrowError = userInfoThrowError
    },
    [types.SMALL_DEVICE](state, smallDevice) {
      state.smallDevice = smallDevice
    },
    [types.LANGUAGE](state, language) {
      state.language = language
    },
    TOGGLE_SIDEBAR(state) {
      state.toggleSidebar = !state.toggleSidebar
    },
    TOGGLE_MAINSIDEBAR(state) {
      state.toggleMainSidebar = !state.toggleMainSidebar
    },
    ALERT_MESSAGE(state, data) {
      state.alertMessage = data
    },
    STORE_CALLBACK(state, fn) {
      state.storeCallback = fn
    },
    USER_PROFILE(state, userProfile) {
      state.UserLoginData = userProfile
    },
    /*********KEEP**********/
    KEEP_SEARCHRSV(state, data) {
      if (data.active == true) {
        //keep
        state.keepSearchReserve.deltaContactName = data.deltaContactName
        state.keepSearchReserve.vendor = data.vendor
        state.keepSearchReserve.reserveNo = data.reserveNo
        state.keepSearchReserve.OACode = data.OACode
        state.keepSearchReserve.reserveArea = data.reserveArea
        state.keepSearchReserve.enterReason = data.enterReason
        state.keepSearchReserve.reserveFactory = data.reserveFactory
        state.keepSearchReserve.reserveStatus = data.reserveStatus
        state.keepSearchReserve.reserveArriveTime = data.reserveArriveTime
        state.keepSearchReserve.applyDatetime = data.applyDatetime
      } else {
        //clear
        state.keepSearchReserve.deltaContactName = ""
        state.keepSearchReserve.vendor = ""
        state.keepSearchReserve.reserveNo = ""
        state.keepSearchReserve.OACode = ""
        state.keepSearchReserve.reserveArea = ""
        state.keepSearchReserve.enterReason = ""
        state.keepSearchReserve.reserveFactory = ""
        state.keepSearchReserve.reserveStatus = ""
        state.keepSearchReserve.reserveArriveTime = ""
        state.keepSearchReserve.applyDatetime = ""
      }
    },
    KEEP_SERCHVENDOR(state, data) {
      if (data.active == true) {
        //keep
        state.keepSearchVendor.oacode = data.oacode
        state.keepSearchVendor.vendor = data.vendor
        state.keepSearchVendor.area = data.area
        state.keepSearchVendor.driverName = data.driverName
        state.keepSearchVendor.carPlat = data.carPlat
        state.keepSearchVendor.driverLicience = data.driverLicience
        state.keepSearchVendor.carState = data.carState
        state.keepSearchVendor.driverState = data.driverState
        state.keepSearchVendor.carType = data.carType
      } else {
        //clear
        state.keepSearchVendor.oacode = ""
        state.keepSearchVendor.vendor = ""
        state.keepSearchVendor.area = ""
        state.keepSearchVendor.driverName = ""
        state.keepSearchVendor.carPlat = ""
        state.keepSearchVendor.driverLicience = ""
        state.keepSearchVendor.carState = ""
        state.keepSearchVendor.driverState = ""
        state.keepSearchVendor.carType = ""
      }
    },
    KEEP_SERCHFACTORY(state, data) {
      if (data.active == true) {
        //keep
        state.keepSearchFactory.region = data.region
        state.keepSearchFactory.area = data.area
        state.keepSearchFactory.factory = data.factory
        state.keepSearchFactory.cartype = data.cartype
      } else {
        //clear
        state.keepSearchFactory.region = ""
        state.keepSearchFactory.area = ""
        state.keepSearchFactory.factory = ""
        state.keepSearchFactory.cartype = ""
      }
    },
    KEEP_SERCHAUTH(state, data) {
      if (data.active == true) {
        //keep
        state.keepSearchAuth.region = data.region
        state.keepSearchAuth.area = data.area
        state.keepSearchAuth.factory = data.factory
        state.keepSearchAuth.role = data.role
        state.keepSearchAuth.userName = data.userName
        state.keepSearchAuth.userID = data.userID
        state.keepSearchAuth.userPhone = data.userPhone
        state.keepSearchAuth.userMail = data.userMail
      } else {
        //clear
        state.keepSearchAuth.region = ""
        state.keepSearchAuth.area = ""
        state.keepSearchAuth.factory = ""
        state.keepSearchAuth.role = ""
        state.keepSearchAuth.userName = ""
        state.keepSearchAuth.userID = ""
        state.keepSearchAuth.userPhone = ""
        state.keepSearchAuth.userMail = ""
      }
    },
    KEEP_SEARCHVENDORRSV(state, data) {
      if (data.active == true) {
        //keep
        state.keepSearchVendorReserve.reserveArea = data.reserveArea
        state.keepSearchVendorReserve.enterReason = data.enterReason
        state.keepSearchVendorReserve.reserveFactory = data.reserveFactory
        state.keepSearchVendorReserve.reserveStatus = data.reserveStatus
        state.keepSearchVendorReserve.reserveArriveTime = data.reserveArriveTime
        state.keepSearchVendorReserve.applyDatetime = data.applyDatetime
      } else {
        //clear
        state.keepSearchVendorReserve.reserveArea = ""
        state.keepSearchVendorReserve.enterReason = ""
        state.keepSearchVendorReserve.reserveFactory = ""
        state.keepSearchVendorReserve.reserveStatus = ""
        state.keepSearchVendorReserve.reserveArriveTime = ""
        state.keepSearchVendorReserve.applyDatetime = ""
      }
    },
    /***************-BASE-***************/
    GET_REGION(state, data) {
      state.regionBase = data
    },
    GET_AREA(state, data) {
      state.areaBase = data
    },
    GET_FACTORY(state, data) {
      state.factoryBase = data
    },
    GET_LOCATION(state, data) {
      state.locationBase = data
    },
    GET_CARTYPE(state, data) {
      state.cartypeBase = data
    },
    GET_GATE(state, data) {
      state.gateBase = data
    },
    GET_ROLE(state, data) {
      state.roleBase = data
    },
    GET_JOB(state, data) {
      state.jobBase = data
    },
    GET_CAR_COLOR(state, data) {
      state.carColorBase = data
    },
    GET_ENTER_REASON(state, data) {
      state.enterReasonBase = data
    },
    GET_REGION_AREA_FACTORY(state, data) {
      state.regionAreaFactory = data
    },
    GET_CODE_CULTURE(state, data) {
      state.codeCultureBase = data
    },
    /***************-FACTORY MAINTAIN-***************/
    GET_FACTORY_LOCATION_TABLE(state, data) {
      state.locationTable = data
    },
    GET_FACTORY_CARTYPE_TABLE(state, data) {
      state.cartypeTable = data
    },
    GET_LOCATION_BY_FACTORY(state, data) {
      if (data != null) {
        state.locationByFactory = data
      } else {
        state.locationByFactory = []
      }
    },
    /***************-ATHU-***************/
    GET_USER_INFO(state, data) {
      state.userInfo = data
    },
    GET_AUTH_TABLE(state, data) {
      state.authTable = data
    },
    /***************-VENDOR-***************/
    GET_VENDOR_BY_OACODE(state, data) {
      state.vendorByOACode = data[0]
    },
    GET_VENDOR_TABLE(state, data) {
      state.carTable = data.carTable
      state.driverTable = data.driverTable
      state.vendorTable = data.vendorTable
    },
    GET_VENDOR_INFO(state, data) {
      state.carDataInfo = data.carData
      state.driverDataInfo = data.driverData
      state.contactDataInfo = data.contactData
      state.vendorDataInfo = data.vendorData
    },
    GET_VENDOR_AREA_BY_OACODE(state, data) {
      state.vendorAreaByOACode = data
    },
    GET_VENDOR_FACTORY_BY_ID(state, data) {
      state.vendorFactoryById = data
    },
    GET_VENDOR_WITH_PASSWORD_CHANG(state, data) {
      state.vendorWithPasswordChange = data
    },
    GET_VENDOR_FACTORY_BY_OACODE(state, data) {
      state.vendorFactoryByOacode = data
    },

    /***************-RESERVE-***************/
    GET_RESERVE_TABLE(state, data) {
      state.reserveTable = data
    },
    GET_QUERY_RESERVE_TABLE(state, data) {
      state.queryReserveTable = data
    },
    GET_RESERVE_INFO(state, data) {
      state.reserveInfo = data
    },
    GET_RELEASE_NUM(state, data) {
      var releaseNum = data.code == 0 ? data.result : "None"

      state.releaseNum = releaseNum
    },
    /***************-GUARD-***************/
    GETGUARDRESERVATIONLIST(state, parameter) {
      state.guardReservationList = parameter
    },
    /***************-RELEASE-***************/
    GET_RELEASE_TABlE(state, parameter) {
      state.releaseTable = parameter
    },
    GET_RELEASE_INFO(state, parameter) {
      state.releaseInfo = parameter
    },
    GET_SO_CREDIT(state, parameter) {
      state.soCredit = parameter
    },
    GET_SIGN_TABLE(state, parameter) {
      state.signTable = parameter
    },
  },
  actions: {
    /***************-GENERAL-***************/
    setSmallDevice(context, smallDevice) {
      context.commit(types.SMALL_DEVICE, smallDevice)
    },
    setLogin(context, login) {
      context.commit(types.LOGIN, login)
    },
    setRedirectUrl(context, redirectUrl) {
      context.commit(types.REDIRECT_URL, redirectUrl)
    },
    setLanguage(context, language) {
      context.commit(types.LANGUAGE, language)
    },
    setUserInfoThrowError(context, userInfoThrowError) {
      context.commit(types.USERINFO_THROW_ERROR, userInfoThrowError)
    },
    toggleSidebar(context, parameter) {
      context.commit("TOGGLE_SIDEBAR")
    },
    toggleMainSidebar(context, parameter) {
      context.commit("TOGGLE_MAINSIDEBAR")
    },
    setUserProfile(context, userProfile) {
      context.commit("USER_PROFILE", userProfile)
    },
    /***************-KEEP-***************/
    KeepSearchReserve(context, parameter) {
      context.commit("KEEP_SEARCHRSV", parameter)
    },
    KeepSearchVendor(context, parameter) {
      context.commit("KEEP_SERCHVENDOR", parameter)
    },
    KeepSearchFactory(context, parameter) {
      context.commit("KEEP_SERCHFACTORY", parameter)
    },
    KeepSearchAuth(context, parameter) {
      context.commit("KEEP_SERCHAUTH", parameter)
    },
    setPrevPageParams(context, payload) {
      context.commit("SET_PREV_PAGE_PARAMS", payload)
    },

    /***************-BASE-***************/
    getRegion(context, params) {
      api
        .apiGetRegion(params)
        .then((response) => {
          context.commit("GET_REGION", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getArea(context, params) {
      api
        .apiGetArea(params)
        .then((response) => {
          context.commit("GET_AREA", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFactory(context, params) {
      api
        .apiGetFactory(params)
        .then((response) => {
          context.commit("GET_FACTORY", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getLocation(context) {
      api
        .apiGetLocation()
        .then((response) => {
          context.commit("GET_LOCATION", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCartype(context) {
      api
        .apiGetCartype()
        .then((response) => {
          context.commit("GET_CARTYPE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getGate(context) {
      api
        .apiGetGate()
        .then((response) => {
          context.commit("GET_GATE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getRole(context) {
      api
        .apiGetRole()
        .then((response) => {
          context.commit("GET_ROLE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getJob(context) {
      api
        .apiGetJob()
        .then((response) => {
          context.commit("GET_JOB", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCarColor(context) {
      api
        .apiGetCarColor()
        .then((response) => {
          context.commit("GET_CAR_COLOR", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getEnterReason(context) {
      api
        .apiGetEnterReason()
        .then((response) => {
          context.commit("GET_ENTER_REASON", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getRegionAreaByFactory(context, parameter) {
      api
        .apiGetRegionAreaByFactory(parameter)
        .then((response) => {
          context.commit("GET_REGION_AREA_FACTORY", response.data)
        })
        .catch((error) => {})
    },
    setCodeCulture(context, parameter) {
      context.commit("GET_CODE_CULTURE", parameter)
    },
    /***************-FACTORY MAINTAIN-***************/
    getLocationByFactory(context, parameter) {
      api
        .apiGetLocationByFactory(parameter)
        .then((response) => {
          context.commit("GET_LOCATION_BY_FACTORY", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFactoryLocationTable(context, parameter) {
      api
        .apiGetFactoryLocationTable(parameter)
        .then((response) => {
          context.commit("GET_FACTORY_LOCATION_TABLE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    addOrUpdateFactoryLocation(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiAddOrUpdateFactoryLocation(parameter)
        .then((response) => {
          response.data.cb = cb
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteFactoryLocation(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiDeleteFactoryLocation(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    addOrUpdateFactoryCarType(context, payload) {
      var parameter = payload.params
      var cb = payload.cb
      api
        .apiAddOrUpdateFactoryCarType(parameter)
        .then((response) => {
          response.data.cb = cb
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFactoryCartypeTable(context, parameter) {
      api
        .apiGetFactoryCartypeTable(parameter)
        .then((response) => {
          context.commit("GET_FACTORY_CARTYPE_TABLE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteFactoryCartype(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiDeleteFactoryCartype(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-AUTH-***************/
    getUserInfo(context, parameter) {
      api
        .apiGetUserInfo(parameter)
        .then((response) => {
          context.commit("GET_USER_INFO", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    upsertAuth(context, payload) {
      //alert

      var parameter = payload.params
      var cb = payload.cb

      api
        .apiUpsertAuth(parameter)
        .then((response) => {
          response.data.cb = cb
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteAuth(context, payload) {
      //alert
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiDeleteAuth(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getAuthTable(context, parameter) {
      api
        .apiGetAuthTable(parameter)
        .then((response) => {
          context.commit("GET_AUTH_TABLE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getUserAuthInfo(context, parameter) {
      api
        .apiGetUserAuthInfo(parameter)
        .then((response) => {
          context.commit("GET_USER_INFO", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-VENDOR-***************/
    getVendorByOACode(context, parameter) {
      api
        .apiGetVendorByOACode(parameter)
        .then((response) => {
          context.commit("GET_VENDOR_BY_OACODE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorAreaByOACode(context, parameter) {
      api
        .apiGetVendorAreaByOACode(parameter)
        .then((response) => {
          context.commit("GET_VENDOR_AREA_BY_OACODE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorFactoryByOAcode(context, parameter) {
      api
        .apiGetFactoryByOAcode(parameter)
        .then((response) => {
          context.commit("GET_VENDOR_FACTORY_BY_OACODE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorFactoryById(context, parameter) {
      api
        .apiGetVendorFactoryById(parameter)
        .then((response) => {
          context.commit("GET_VENDOR_FACTORY_BY_ID", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    createVendor(context, payload) {
      var parameter = payload.params
      var cb = payload.cb
      api
        .apiCreateVendor(parameter)
        .then((response) => {
          response.data.cb = cb
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    disableVendorDriver(context, payload) {
      var parameter = payload.params
      var cb = payload.cb
      api
        .apiDisableVendorDriver(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    disableVendorCar(context, payload) {
      var parameter = payload.params
      var cb = payload.cb
      api
        .apiDisableVendorCar(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorTable(context, parameter) {
      api
        .apiGetVendorTable(parameter)
        .then((response) => {
          context.commit("GET_VENDOR_TABLE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorInfo(context, parameter) {
      api
        .apiGetVendorInfo(parameter)
        .then((response) => {
          if (response.data.code == 1) {
            context.commit("GET_VENDOR_INFO", response.data.result)
          } else {
            context.commit("ALERT_MESSAGE", response.data.result)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    upsertVendor(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiUpsertVendor(parameter)
        .then((response) => {
          response.data.cb = cb
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    disableVendor(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiDisableVendor(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    resetVendorPassword(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiResetVendorPassword(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            response.data.cb = cb
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getVendorWithPasswordChage(context, parameter) {
      api
        .apiGetVendorWithPasswordChage(parameter)
        .then((response) => {
          context.commit("GET_VENDOR_WITH_PASSWORD_CHANG", response.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-RESERVE-***************/
    upsertReserveByUser(context, payload) {
      var parameter = payload.params
      var cb = payload.cb
      var status = payload.params.reserveData.reserveStatus

      api
        .apiUpsertReserveByUser(parameter)
        .then((response) => {
          response.data.cb = cb

          if (status == "cancel" || status == "tempCancel") {
            context.commit("STORE_CALLBACK", { fn: cb })
          } else {
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReserveTable(context, parameter) {
      api
        .apiGetReserveTable(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            //if(response.data.result.length>0){
            context.commit("GET_RESERVE_TABLE", response.data.result)
            //}/*else{
            //context.commit('ALERT_MESSAGE',{code:1, message:'Cannot Found Data'})
            //}*/
          } else {
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getQueryReserveTable(context, parameter) {
      api
        .apiGetQueryReserveTable(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("GET_QUERY_RESERVE_TABLE", response.data.result)
          } else {
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReserveInfo(context, parameter) {
      api
        .apiGetReserveInfo(parameter)
        .then((response) => {
          context.commit("GET_RESERVE_INFO", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReleaseNum(context, parameter) {
      api
        .apiGetReleaseNum(parameter)
        .then((response) => {
          context.commit("GET_RELEASE_NUM", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-GUARD-***************/
    upsertInspectByGuard(context, payload) {
      var parameter = payload.params
      var cb = payload.cb
      api
        .apiUpsertInspectByGuard(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("STORE_CALLBACK", { fn: cb })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-RELEASE-***************/
    getReleaseTable(context, parameter) {
      api
        .apiGetReleaseTable(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("GET_RELEASE_TABlE", response.data.result)
          } else {
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateRelease(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiUpdateRelease(parameter)
        .then((response) => {
          if (parameter.releaseData.releaseOrderStatus == "cancel") context.commit("STORE_CALLBACK", { fn: cb })
          else context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateReleaseStatus(context, payload) {
      api
        .apiUpdateReleaseStatus(payload)
        .then((response) => {})
        .catch((error) => {
          console.log(error)
        })
    },
    getReleaseInfo(context, parameter) {
      api
        .apiGetReleaseInfo(parameter)
        .then((response) => {
          context.commit("GET_RELEASE_INFO", response.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSoCredit(context, parameter) {
      api
        .apiGetSOCredit(parameter.params)
        .then((response) => {
          context.commit("GET_SO_CREDIT", response.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateSO(context, parameter) {
      api
        .apiUpdateSO(parameter.params)
        .then((response) => {
          //context.commit('UPDATE_SO', response.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateReleaseANSo(context, parameter) {
      api
        .apiUpdateReleaseANSo(parameter.params)
        .then(
          axios.spread((releaseData, soData) => {
            var releaseDataCode = releaseData.data.code
            var soDataCode = soData.data.code
            soData.data.cb = parameter.cb
            if (releaseDataCode == 0 && soDataCode == 0) context.commit("ALERT_MESSAGE", soData.data)
          })
        )
        .catch((error) => {
          console.log(error)
        })
    },
    getSignTable(context, parameter) {
      api
        .apiGetSignTable(parameter.params)
        .then((response) => {
          if (response.data.code == 0) context.commit("GET_SIGN_TABLE", response.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReleaseTableWithSign(context, parameter) {
      api
        .apiGetReleaseTableWithSign(parameter)
        .then((response) => {
          context.commit("GET_RELEASE_TABlE", response.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateReleaseANSign(context, parameter) {
      api
        .apiUpdateReleaseANSign(parameter.params)
        .then(
          axios.spread((releaseData, signData) => {
            var releaseDataCode = releaseData.data.code
            var signDataCode = signData.data.code
            signData.data.cb = parameter.cb
            if (releaseDataCode == 0 && signDataCode == 0) context.commit("ALERT_MESSAGE", signData.data)
          })
        )
        .catch((error) => {
          console.log(error)
        })
    },
    updateReleaseSignList(context, parameter) {
      api
        .apiUpdateSignList(parameter.params)
        .then((response) => {
          response.data.cb = parameter.cb
          if (response.data.code == 0) context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***********ERP*************/
    updateSoToERP(context, parameter) {
      api
        .apiUpdateSoToERP(parameter)
        .then((response) => {
          if (response.data.code < 0) context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    postReleaseStatusToERP(context, parameter) {
      api
        .apiPostReleaseStatusToERP(parameter)
        .then((response) => {
          if (response.data.code < 0) context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
})
